import { render, staticRenderFns } from "./FactorBaseRevealHeatmap.vue?vue&type=template&id=a8bcd602"
import script from "./FactorBaseRevealHeatmap.vue?vue&type=script&lang=js"
export * from "./FactorBaseRevealHeatmap.vue?vue&type=script&lang=js"
import style0 from "./FactorBaseRevealHeatmap.vue?vue&type=style&index=0&id=a8bcd602&lang=css"
import style1 from "./FactorBaseRevealHeatmap.vue?vue&type=style&index=1&id=a8bcd602&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a8bcd602')) {
      api.createRecord('a8bcd602', component.options)
    } else {
      api.reload('a8bcd602', component.options)
    }
    module.hot.accept("./FactorBaseRevealHeatmap.vue?vue&type=template&id=a8bcd602", function () {
      api.rerender('a8bcd602', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/FactorBaseRevealHeatmap.vue"
export default component.exports